import { UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Typography } from 'antd';
import { Investment, Investor } from 'procura-shared';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { updateEmailAdmin } from '../api/calls/auth';
const { Paragraph } = Typography;

type ChangeLoginEmailButtonProps = {
  investor?: Investor;
  investment?: Investment;
  style?: React.CSSProperties;
};

export const ChangeLoginEmailButton = ({ investor, investment, style }: ChangeLoginEmailButtonProps) => {
  const { t } = useTranslation();

  const canRender = (): boolean => investor != null;
  const label = (): string => investor.name ?? investor.contactEmail ?? investor.id;

  const emailSubmitHandler = async (values) => {
    await updateEmailAdmin(values.email, investor.id);
  };

  const emailModal = () =>
    Modal.confirm({
      title: (
        <>
          Change login email for: <Paragraph code>{label()}</Paragraph>
        </>
      ),
      okButtonProps: { style: { display: 'none' } },
      content: (
        <div style={{ marginTop: 24 }}>
          <Form onFinish={emailSubmitHandler} layout="vertical">
            <Form.Item name="email" rules={[{ required: true, message: t('emailInvalid'), type: 'email' }]}>
              <Input type="email" placeholder={t('newEmail')} prefix={<UserOutlined />} />
            </Form.Item>
            <Button type="primary" ghost htmlType="submit">
              {t('change')}
            </Button>
          </Form>
        </div>
      ),
    });

  return (
    canRender() && (
      <>
        <Button type="primary" ghost style={style} onClick={emailModal}>
          Change login email
        </Button>
      </>
    )
  );
};
